import { Building2, FilePenLine, FileSignature, Globe, Sparkles, UserRound } from "lucide-react";
import { useT } from "@/i18n";

function Choice({ id, active, icon: Icon, title, sub, onClick }) {
  return (
    <button
      type="button"
      data-testid={id}
      aria-pressed={active}
      onClick={onClick}
      className={`text-left rounded-xl border p-4 transition-all duration-200 flex gap-3 items-start ${active ? "border-brand-teal bg-brand-teal/5 ring-1 ring-brand-teal/40" : "border-border hover:border-slate-400 hover:bg-muted/50"}`}
    >
      <span className={`w-9 h-9 rounded-lg flex items-center justify-center shrink-0 ${active ? "bg-brand-teal text-white" : "bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300"}`}><Icon size={17} /></span>
      <span>
        <span className="block text-sm font-semibold">{title}</span>
        {sub && <span className="block text-xs text-muted-foreground mt-0.5 leading-relaxed">{sub}</span>}
      </span>
    </button>
  );
}

function Group({ label, children, testid }) {
  return (
    <div data-testid={testid} className="space-y-2">
      <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-muted-foreground">{label}</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">{children}</div>
    </div>
  );
}

export function ModeSelector({ choice, onChange }) {
  const { t } = useT();
  const W = t.order.wizard;
  const set = (patch) => onChange({ ...choice, ...patch });
  return (
    <div className="space-y-4">
      <Group label={W.mode_title} testid="order-mode-group">
        <Choice id="order-mode-existing" active={choice.mode === "existing"} icon={Building2} title={W.mode_existing} sub={W.mode_existing_sub} onClick={() => onChange({ mode: "existing", kind: null, way: null })} />
        <Choice id="order-mode-new" active={choice.mode === "new"} icon={Sparkles} title={W.mode_new} sub={W.mode_new_sub} onClick={() => set({ mode: "new" })} />
      </Group>
      {choice.mode === "new" && (
        <Group label={W.kind_title} testid="order-kind-group">
          <Choice id="order-kind-jdg" active={choice.kind === "jdg"} icon={UserRound} title={W.kind_jdg} onClick={() => set({ kind: "jdg", way: null })} />
          <Choice id="order-kind-krs" active={choice.kind === "krs"} icon={FileSignature} title={W.kind_krs} onClick={() => set({ kind: "krs" })} />
        </Group>
      )}
      {choice.mode === "new" && choice.kind === "krs" && (
        <Group label={W.krs_title} testid="order-way-group">
          <Choice id="order-way-deed" active={choice.way === "deed"} icon={FilePenLine} title={W.krs_deed} onClick={() => set({ way: "deed" })} />
          <Choice id="order-way-s24" active={choice.way === "s24"} icon={Globe} title={W.krs_s24} onClick={() => set({ way: "s24" })} />
        </Group>
      )}
    </div>
  );
}

export function entityModeOf(choice) {
  if (choice.mode === "existing") return "existing";
  if (choice.mode === "new" && choice.kind === "jdg") return "new_jdg";
  if (choice.mode === "new" && choice.kind === "krs" && choice.way === "deed") return "new_krs_deed";
  if (choice.mode === "new" && choice.kind === "krs" && choice.way === "s24") return "new_krs_s24";
  return null;
}
